import _ from 'lodash';
import { EmbedsFusionApiServiceConfig } from './interfaces';
import { ApiMeta, FusionApiService } from 'ui-common';

export class EmbedsFusionApiService extends FusionApiService {
  static apiMeta: ApiMeta = {
    searchDSL: {
      uri : '/query',

      methods : [{
        uri : '/query/{queryProfileId}',
        name : 'query',
        verb : 'POST',
        hasEntity : false,
      }],
    },
  };

  constructor(config: EmbedsFusionApiServiceConfig) {
    super(_.merge({
      getServiceHost: () => `${config.apiUrl}/api/apps/${config.appId}`,
      apiPath: '',
      apiMeta: EmbedsFusionApiService.apiMeta,
    }, config));
  }
}